import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/api/client";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [state, setState] = useState({ loading: true, user: null, needsSetup: false, error: null });

  const refresh = useCallback(async () => {
    try {
      const { user, needs_setup } = await api.auth.state();
      setState({ loading: false, user, needsSetup: needs_setup, error: null });
      return user;
    } catch (err) {
      setState({ loading: false, user: null, needsSetup: false, error: err.message });
      return null;
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const value = useMemo(
    () => ({
      ...state,
      isAdmin: state.user?.role === "admin",
      refresh,
      setUser: (user) => setState((s) => ({ ...s, user, needsSetup: false })),
      logout: async () => {
        await api.auth.logout().catch(() => {});
        setState((s) => ({ ...s, user: null }));
      },
    }),
    [state, refresh],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
}
